import { useTranslation } from 'react-i18next'
import type { SelectEntry } from '#components/Select'

import type { ConfigurationMode } from '#features/Configuration/ApiConfiguration'

export const useTranslatedManCodeOptionEntries = () => {
  const { t } = useTranslation()
  const entries: SelectEntry<ConfigurationMode>[] = [
    { id: 'writable', value: t('setup.code.writable', 'Writeable') },
    { id: 'read-only', value: t('setup.code.read-only', 'Read-Only') },
    { id: 'stashed', value: t('setup.code.stashed', 'Stashed') },
    { id: 'cloned', value: t('setup.code.cloned', 'Cloned') },
  ]
  return entries
}
